var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.834 8H8.50065C5.55513 8 3.16732 10.3878 3.16732 13.3333V24C3.16732 26.9455 5.55513 29.3333 8.50065 29.3333H24.5007C27.4462 29.3333 29.834 26.9455 29.834 24V8Z",
    fill: "#005DAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8337 7.99984C29.8337 5.05432 27.4458 2.6665 24.5003 2.6665H16.5003C13.5548 2.6665 11.167 5.05432 11.167 7.99984H29.8337Z",
    fill: "#005DAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16699 16L3.16699 21.3333L8.50033 21.3333C9.97308 21.3333 11.167 20.1394 11.167 18.6667C11.167 17.1939 9.97308 16 8.50033 16L3.16699 16Z",
    fill: "#005DAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.183fd794eae3639be0e9671f82f9b441.svg";
export { ForwardRef as ReactComponent };